import { render, staticRenderFns } from "./BusinessAttributesView.vue?vue&type=template&id=0e0f43b6&scoped=true&"
import script from "./BusinessAttributesView.vue?vue&type=script&lang=ts&"
export * from "./BusinessAttributesView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessAttributesView.vue?vue&type=style&index=0&id=0e0f43b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0f43b6",
  null
  
)

export default component.exports